import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import MobileSidebar from "../../Dashboard/DashboardHeader/MobileSidebar/MobileSidebar";
import "./i-dashboard-header.style.scss";
export default function IDashboardHeader() {
  const history = useHistory()
  const [headerList,  setHeaderList] = React.useState(listOption);
  const [contentInside, setContentInside] = React.useState("");
  const context = React.useContext(MainContext)
  const{userDetails, jobListPage,updateState} = context
  const handleClick = (obj) => {
    switch (obj.id) {
      case "myProfile":
        history.push("/institute/profile");
        break;
      case "logout":
        localStorage.clear();
        updateState("userDetails", null);
        history.push("/");
        

        break;

      default:
        break;
    }
  };
  return (
    <>
      <header className="dashboard-header-main">
        <nav>
          <Link to="/institute">
            <img src={Images.mainLogo} alt="main" />
          </Link>
          <ul>
            {headerList.map((obj) => (
              <li>
                <Link
                  onClick={() => updateState("jobListPage", obj.id)}
                  className={obj.id === jobListPage ? "current-page" : ""}
                  key={obj.keyId}
                  to={`/institute/${obj.id}`}
                >
                  {obj.name}
                  {obj.count && `(${obj.count})`}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="dhm-right">
          <div className="dhmr-left">
            <div className="notification-wrapper">
              <img className="bell-icon" src={Images.bellIcon} />
              <div className="notification-list-wrapper">
                <img className="top-point" src={Images.whiteTriangle} />
                <header className="nlw-header">
                  <h6>Notifications</h6>
                </header>
                <div className="nlw-body">
                  {[1, 2, 3, 4, 5].map((obj) => (
                    <div className="nlw-row">
                      <img src={Images.suitcaseLogo} />
                      <div>
                        <p>
                          Your application to Gera Institute is under review
                        </p>
                      </div>
                      <span>1h ago</span>
                    </div>
                  ))}
                </div>
                <footer className="nlw-footer">
                  <p>View all notifications</p>
                </footer>
              </div>
            </div>
          </div>
          {/* src="https://img.icons8.com/material-sharp/50/ffffff/sort-down.png" */}
          <div className="dhmr-right">
            {!userDetails ? (
              <Link to="/login" className="dhmr-login">
                <span>Login/Register</span>
              </Link>
            ) : (
              <div className="dhmr-logged ">
                <img
                  className="dp"
                  height="20px"
                  src={userDetails?.institution_logo}
                />
                <p className="username">{userDetails?.institution_name || "NA"}</p>
                <img
                  className="arrow"
                  src="https://img.icons8.com/material-sharp/50/ffffff/sort-down.png"
                />

                <div className="dhmr-dropdown">
                  <div className="dhmrd-header">
                    <img src={userDetails?.institution_logo} />
                    <div>
                      <h6>{userDetails?.institution_name || "NA"}</h6>
                      <p>{userDetails?.institution_primary_email}</p>
                    </div>
                  </div>
                  {dropdownLists.map((obj) => (
                    <ul key={obj.keyId}>
                      {obj.list.map((x) => (
                        <li onClick={() => handleClick(x)} key={x.keyId}>
                          {x.name}
                        </li>
                      ))}
                    </ul>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </header>
      <header className="dashboard-header-main-mobile">
        <nav className="dhmm-at-display">
          <img src={Images.mainLogo} />
          <button
            onClick={() => setContentInside("home")}
            className="dhmmad-button"
          >
            <img src="https://img.icons8.com/material-rounded/48/000000/menu--v1.png" />
          </button>
        </nav>
        {contentInside && (
          <MobileSidebar
            setContentInside={setContentInside}
            content={contentInside}
            userDetails={userDetails}
            type="institute"
          />
        )}
      </header>
    </>
  );
}

const listOption = [
  { keyId: nextId(), name: "jobs List", id: "jobs-list" },
  { keyId: nextId(), name: "Saved Application", id: "saved-application" },
];

const dropdownLists = [
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "My Profile", id: "myProfile" }],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "jobs List", id: "jobs-list" },
      { keyId: nextId(), name: "Saved Application", id: "saved-application" },
    ],
  },
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "Notifications", id: "notification" }],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "Help", id: "help" },
      { keyId: nextId(), name: "Feedback", id: "fb" },
    ],
  },
  {
    keyId: nextId(),
    list: [{ keyId: nextId(), name: "Log Out", id: "logout" }],
  },
];
